/**
 * PDP bundle contents: parse Fly Config JSON, fetch child variants via
 * Storefront GraphQL, render cards, add selected variants to cart.
 */
//@ts-nocheck

(function (global) {
  'use strict';

  if (global.__bundleContentsLoaded) return;
  global.__bundleContentsLoaded = true;

  var STOREFRONT_API_PATH = '/api/2025-01/graphql.json';
  var VARIANT_DETAILS_QUERY =
    'query BundleContentsVariants($ids: [ID!]!) {' +
    '  nodes(ids: $ids) {' +
    '    ... on ProductVariant {' +
    '      id' +
    '      title' +
    '      availableForSale' +
    '      price { amount }' +
    '      compareAtPrice { amount }' +
    '      image { url(transform: { maxWidth: 200 }) altText }' +
    '      product {' +
    '        id' +
    '        title' +
    '        featuredImage { url(transform: { maxWidth: 200 }) altText }' +
    '      }' +
    '    }' +
    '  }' +
    '}';

  function toVariantGid(id) {
    return 'gid://shopify/ProductVariant/' + String(id);
  }

  function fromVariantGid(gid) {
    return String(gid || '').replace('gid://shopify/ProductVariant/', '');
  }

  function getStorefrontToken() {
    return (
      global.PW_STOREFRONT_TOKEN ||
      global.__PW_STOREFRONT_TOKEN__ ||
      ''
    );
  }

  function escapeHtml(value) {
    if (value == null) return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function toAmount(value) {
    var num = typeof value === 'string' ? parseFloat(value) : Number(value);
    return Number.isFinite(num) ? num : 0;
  }

  function formatPrice(amount, currencyCode) {
    var num = toAmount(amount);
    if (!num && amount !== 0 && amount !== '0') return '';
    var grouped = Math.round(num).toLocaleString('en-IN');
    var symbol = currencyCode === 'INR' || !currencyCode ? '\u20B9 ' : currencyCode + ' ';
    return symbol + grouped;
  }

  function discountPercent(price, compare) {
    if (!(compare > price) || compare <= 0) return 0;
    return Math.round(((compare - price) * 100) / compare);
  }

  function computeBundleTotal(items) {
    var price = 0;
    var compare = 0;
    for (var i = 0; i < items.length; i++) {
      var itemPrice = toAmount(items[i].price);
      var itemCompare = toAmount(items[i].compareAtPrice);
      price += itemPrice;
      compare += itemCompare > itemPrice ? itemCompare : itemPrice;
    }
    return { price: price, compare: compare };
  }

  function readSuperbundlePrice(root) {
    var price = toAmount(root.dataset.superbundlePrice);
    var compare = toAmount(root.dataset.superbundleComparePrice);
    if (price > 0) return { price: price, compare: compare };
    return null;
  }

  function priceInfoSvg() {
    return (
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">' +
      '<circle cx="7" cy="7" r="6.25" stroke="currentColor" stroke-width="1.5"/>' +
      '<path d="M7 6.25V9.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      '<circle cx="7" cy="4.5" r="0.75" fill="currentColor"/>' +
      '</svg>'
    );
  }

  function itemsInfoSvg() {
    return (
      '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" aria-hidden="true">' +
      '<circle cx="7" cy="7" r="7" fill="currentColor"/>' +
      '<path d="M7 6.25V9.75" stroke="#fff" stroke-width="1.5" stroke-linecap="round"/>' +
      '<circle cx="7" cy="4.5" r="0.75" fill="#fff"/>' +
      '</svg>'
    );
  }

  function renderPriceInfo(tooltipId, sellingText, mrpText, percent) {
    var mrpOnly = !(percent > 0);
    var mrpValue = mrpOnly ? sellingText : mrpText;
    return (
      '<span class="price-info-wrap-pdp bundle-contents__price-info">' +
        '<button type="button" class="price-info-btn-pdp" aria-label="Price details" aria-expanded="false" aria-controls="' +
        tooltipId +
        '" data-price-info-trigger>' +
        priceInfoSvg() +
        '</button>' +
        '<div id="' +
        tooltipId +
        '" class="price-details-tooltip-pdp' +
        (mrpOnly ? ' price-details-tooltip-pdp--mrp-only' : '') +
        '" role="tooltip">' +
          '<p class="price-details-title-pdp">Price Details</p>' +
          '<div class="price-details-row-pdp">' +
            '<div>' +
              '<span class="price-details-label-pdp">Maximum Retail Price</span>' +
              '<span class="price-details-subtext-pdp">(Incl. of all taxes)</span>' +
            '</div>' +
            '<span class="price-details-value-pdp" data-price-detail="mrp">' +
            escapeHtml(mrpValue) +
            '</span>' +
          '</div>' +
          '<hr class="price-details-divider-pdp">' +
          '<div class="price-details-row-pdp price-details-row-pdp--discount">' +
            '<span class="price-details-label-pdp">Discount</span>' +
            '<span class="price-details-value-pdp price-details-value-pdp--discount" data-price-detail="discount">' +
            percent +
            '% OFF</span>' +
          '</div>' +
          '<div class="price-details-row-pdp price-details-row-pdp--selling">' +
            '<div>' +
              '<span class="price-details-label-pdp price-details-label-pdp--bold">Selling Price</span>' +
              '<span class="price-details-subtext-pdp">(Incl. of all taxes)</span>' +
            '</div>' +
            '<span class="price-details-value-pdp price-details-value-pdp--bold" data-price-detail="selling">' +
            escapeHtml(sellingText) +
            '</span>' +
          '</div>' +
        '</div>' +
      '</span>'
    );
  }

  function renderItemsInfo(tooltipId, items) {
    if (!items || !items.length) return '';
    var rows = '';
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var itemPrice = toAmount(item.price);
      var itemCompare = toAmount(item.compareAtPrice);
      var hasCompare = itemCompare > itemPrice;
      var itemPct = hasCompare ? discountPercent(itemPrice, itemCompare) : 0;
      rows +=
        '<div class="bundle-contents__item-detail">' +
          '<p class="bundle-contents__item-detail-title">' +
          escapeHtml(item.title || 'Product') +
          '</p>' +
          '<div class="bundle-contents__item-detail-prices">' +
            (hasCompare
              ? ''
              : '<span class="bundle-contents__mrp">M.R.P</span>') +
            '<span class="bundle-contents__item-detail-sale">' +
            escapeHtml(formatPrice(itemPrice, 'INR')) +
            '</span>' +
            (hasCompare
              ? '<span class="bundle-contents__mrp">M.R.P</span>' +
                '<span class="bundle-contents__item-detail-compare">' +
                escapeHtml(formatPrice(itemCompare, 'INR')) +
                '</span>' +
                '<span class="bundle-contents__item-detail-discount">(' +
                itemPct +
                '% OFF)</span>'
              : '') +
          '</div>' +
        '</div>';
    }

    return (
      '<span class="price-info-wrap-pdp bundle-contents__price-info bundle-contents__items-info">' +
        '<button type="button" class="price-info-btn-pdp" aria-label="Bundle product prices" aria-expanded="false" aria-controls="' +
        tooltipId +
        '" data-price-info-trigger>' +
        itemsInfoSvg() +
        '</button>' +
        '<div id="' +
        tooltipId +
        '" class="price-details-tooltip-pdp bundle-contents__items-tooltip" role="tooltip">' +
          '<p class="price-details-title-pdp">Bundle Products</p>' +
          rows +
        '</div>' +
      '</span>'
    );
  }

  function renderBundleTotal(totalEl, price, compare, tooltipId, items) {
    if (!totalEl) return;
    var percent = discountPercent(price, compare);
    var sellingText = formatPrice(price, 'INR');
    var mrpText = formatPrice(compare, 'INR');
    var productId = (tooltipId || '').replace('bundle-price-details-tooltip-', '') || '0';
    var html = '';
    if (percent > 0) {
      html +=
        '<span class="bundle-contents__price">' +
        escapeHtml(sellingText) +
        '</span>' +
        '<span class="bundle-contents__mrp">M.R.P</span>' +
        '<span class="bundle-contents__compare">' +
        escapeHtml(mrpText) +
        '</span>';
    } else {
      html +=
        '<span class="bundle-contents__mrp">M.R.P</span>' +
        '<span class="bundle-contents__price">' +
        escapeHtml(sellingText) +
        '</span>';
    }
    html += renderPriceInfo(tooltipId || 'bundle-price-details-tooltip', sellingText, mrpText, percent);
    if (percent > 0) {
      html +=
        '<span class="bundle-contents__discount">(' +
        percent +
        '% OFF)</span>';
    }
    html += renderItemsInfo('bundle-items-details-tooltip-' + productId, items);
    totalEl.innerHTML = html;
  }

  /**
   * Fly Config: {"productId":["variantId"], ...}
   * @param {string|object|null} raw
   * @returns {Array<{productId: string, variantId: string}>}
   */
  function parseFlyConfig(raw) {
    if (raw == null || raw === '') return [];

    var data = raw;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return [];
      }
    }
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return [];
      }
    }
    if (!data || typeof data !== 'object' || Array.isArray(data)) return [];

    var pairs = [];
    var productIds = Object.keys(data);
    for (var i = 0; i < productIds.length; i++) {
      var productId = productIds[i];
      var variants = data[productId];
      var variantId = Array.isArray(variants) ? variants[0] : variants;
      if (variantId == null || variantId === '') continue;
      pairs.push({
        productId: String(productId),
        variantId: String(variantId),
      });
    }
    return pairs;
  }

  /**
   * Fetch variant image, price, and title via Storefront GraphQL.
   * @param {string[]} variantIds
   * @returns {Promise<Array<object>>}
   */
  function fetchVariantDetails(variantIds) {
    var token = getStorefrontToken();
    if (!token || !variantIds || !variantIds.length) {
      return Promise.resolve([]);
    }

    return fetch(STOREFRONT_API_PATH, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({
        query: VARIANT_DETAILS_QUERY,
        variables: { ids: variantIds.map(toVariantGid) },
      }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (result) {
        var nodes = result && result.data && result.data.nodes;
        return Array.isArray(nodes) ? nodes.filter(Boolean) : [];
      });
  }

  function normalizeNode(node) {
    if (!node) return null;
    var product = node.product || {};
    var image = (node.image && node.image.url) || (product.featuredImage && product.featuredImage.url) || '';
    var alt =
      (node.image && node.image.altText) ||
      (product.featuredImage && product.featuredImage.altText) ||
      product.title ||
      '';
    return {
      variantId: fromVariantGid(node.id),
      productId: String(product.id || '').split('/').pop(),
      title: product.title || node.title || '',
      image: image,
      alt: alt,
      price: node.price ? toAmount(node.price.amount) : 0,
      compareAtPrice: node.compareAtPrice ? toAmount(node.compareAtPrice.amount) : 0,
      available: node.availableForSale !== false,
    };
  }

  function renderSkeleton(root, count) {
    var list = root.querySelector('[data-bundle-list]');
    if (!list) return;
    var n = count > 0 ? count : 2;
    var html = '';
    for (var i = 0; i < n; i++) {
      html +=
        '<li class="bundle-contents__card bundle-contents__card--skeleton" aria-hidden="true">' +
        '<div class="bundle-contents__image skeleton-shimmer"></div>' +
        '<div class="bundle-contents__info">' +
        '<div class="skeleton-text skeleton-shimmer bundle-contents__skel-line"></div>' +
        '<div class="skeleton-text skeleton-shimmer bundle-contents__skel-line bundle-contents__skel-line--short"></div>' +
        '<div class="skeleton-text skeleton-shimmer bundle-contents__skel-price"></div>' +
        '</div>' +
        '</li>';
    }
    list.innerHTML = html;
  }

  function renderCards(root, items) {
    var list = root.querySelector('[data-bundle-list]');
    var totalEl = root.querySelector('[data-bundle-total]');
    if (!list) return;

    if (!items.length) {
      list.innerHTML = '';
      if (totalEl) totalEl.innerHTML = '';
      return;
    }

    var html = '';
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      html +=
        '<li class="bundle-contents__card">' +
        '<div class="bundle-contents__image">' +
        (item.image
          ? '<img src="' +
            escapeHtml(item.image) +
            '" alt="' +
            escapeHtml(item.alt) +
            '" width="88" height="88" loading="lazy">'
          : '') +
        '</div>' +
        '<div class="bundle-contents__info">' +
        '<p class="bundle-contents__title">' +
        escapeHtml(item.title) +
        '</p>' +
        '</div>' +
        '</li>';
    }
    list.innerHTML = html;

    var totals = readSuperbundlePrice(root) || computeBundleTotal(items);
    root.dataset.bundlePrice = totals.price;
    root.dataset.bundleComparePrice = totals.compare;
    renderBundleTotal(
      totalEl,
      totals.price,
      totals.compare,
      'bundle-price-details-tooltip-' + (root.dataset.productId || '0'),
      items
    );
  }

  function addBundleToCart(root) {
    var atcBtn = root.querySelector('[data-bundle-atc]');
    if (root.dataset.bundleOutOfStock === 'true') return;
    if (root.dataset.atcBusy === 'true') return;

    var pairs = parseFlyConfig(root.dataset.flyConfig);
    if (!pairs.length) return;

    var digitalMap = null;
    try {
      digitalMap = JSON.parse(root.dataset.flyDigitalMap || 'null');
    } catch (e) {}

    var offerId = root.dataset.flyOfferId || '';
    var bundleName = root.dataset.productTitle || '';
    var rk = Math.random().toString(36).substring(2, 5);
    var offerIdKeyed = offerId ? offerId + '_' + rk : '';

    var items = [];
    for (var i = 0; i < pairs.length; i++) {
      var variantId = parseInt(pairs[i].variantId, 10);
      if (!variantId) continue;
      var isDigital =
        digitalMap && digitalMap.hasOwnProperty(String(variantId)) ? digitalMap[String(variantId)] === true : false;
      var properties = {
        _digital_book: isDigital ? 'true' : 'false',
        _purchase_type: 'null',
      };
      if (offerIdKeyed) {
        properties['_flyBundles:OfferId'] = offerIdKeyed;
        properties['_flyBundles:prodQty'] = 1;
        properties['_flyBundles:customField'] = bundleName;
      }
      items.push({ id: variantId, quantity: 1, properties: properties });
    }
    if (!items.length) return;

    root.dataset.atcBusy = 'true';
    if (atcBtn) {
      atcBtn.disabled = true;
      atcBtn.classList.add('is-loading');
    }

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { source: 'product-form-component', itemCount: 1, isOptimistic: true } },
      })
    );

    fetch('/cart/add.js?app=gfbBundleApp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error(String(response.status));
        fireTracking(root, atcBtn);
      })
      .catch(function (err) {
        console.error('Bundle contents add-to-cart error:', err);
        fetch('/cart.js')
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            document.dispatchEvent(
              new CustomEvent('cart:update', {
                bubbles: true,
                detail: { data: { source: 'bundle-contents', itemCount: cart.item_count } },
              })
            );
          })
          .catch(function () {});
      })
      .then(function () {
        root.dataset.atcBusy = 'false';
        if (atcBtn) {
          atcBtn.disabled = false;
          atcBtn.classList.remove('is-loading');
        }
      });
  }

  function fireTracking(root, triggerElement) {
    if (typeof global.addToCartGtm !== 'function') return;
    var productData = null;
    try {
      var rawGtm = root.dataset.bundleGtm;
      if (rawGtm) productData = JSON.parse(rawGtm);
    } catch (e) {}
    var payload = Object.assign({}, productData && typeof productData === 'object' ? productData : {}, {
      product_id: root.dataset.productId || null,
      product_variant_id: root.dataset.variantId ? String(root.dataset.variantId) : null,
      product_title: root.dataset.productTitle || null,
      total_quantity: 1,
      cta_name: 'add_to_bag',
      triggerElement: triggerElement || root,
    });
    setTimeout(function () {
      global.addToCartGtm(payload);
    }, 0);
  }

  function loadAndRender(root) {
    var pairs = parseFlyConfig(root.dataset.flyConfig);
    if (!pairs.length) {
      root.hidden = true;
      return Promise.resolve();
    }

    root.hidden = false;
    root.classList.add('is-loading');
    renderSkeleton(root, pairs.length);
    var variantIds = pairs.map(function (pair) {
      return pair.variantId;
    });

    return fetchVariantDetails(variantIds)
      .then(function (nodes) {
        var byId = {};
        for (var i = 0; i < nodes.length; i++) {
          var normalized = normalizeNode(nodes[i]);
          if (normalized && normalized.variantId) byId[normalized.variantId] = normalized;
        }
        var items = [];
        for (var j = 0; j < pairs.length; j++) {
          var match = byId[pairs[j].variantId];
          if (match) items.push(match);
        }
        if (!items.length) {
          root.hidden = true;
          return;
        }
        var outOfStock = items.length !== pairs.length;
        if (!outOfStock) {
          for (var k = 0; k < items.length; k++) {
            if (!items[k].available) {
              outOfStock = true;
              break;
            }
          }
        }
        renderCards(root, items);
        bindPriceInfo(root);
        bindAtc(root, outOfStock);
      })
      .catch(function (err) {
        console.error('Bundle contents fetch error:', err);
        root.hidden = true;
      })
      .then(function () {
        root.classList.remove('is-loading');
      });
  }

  function bindPriceInfo(root) {
    if (root.dataset.priceInfoBound === 'true') return;
    root.dataset.priceInfoBound = 'true';

    root.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-price-info-trigger]');
      var wrap = trigger ? trigger.closest('.price-info-wrap-pdp') : null;
      if (!trigger || !wrap || !root.contains(wrap)) return;

      e.preventDefault();
      e.stopPropagation();
      var isOpen = wrap.classList.contains('is-open');
      root.querySelectorAll('.price-info-wrap-pdp.is-open').forEach(function (openWrap) {
        openWrap.classList.remove('is-open');
        var openTrigger = openWrap.querySelector('[data-price-info-trigger]');
        if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        wrap.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.price-info-wrap-pdp')) return;
      root.querySelectorAll('.price-info-wrap-pdp.is-open').forEach(function (openWrap) {
        openWrap.classList.remove('is-open');
        var openTrigger = openWrap.querySelector('[data-price-info-trigger]');
        if (openTrigger) openTrigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function bindAtc(root, outOfStock) {
    var atcBtn = root.querySelector('[data-bundle-atc]');
    if (!atcBtn) return;

    if (outOfStock) {
      atcBtn.textContent = 'Out of Stock';
      atcBtn.disabled = true;
      root.dataset.bundleOutOfStock = 'true';
      return;
    }

    atcBtn.textContent = 'Add to Bag';
    atcBtn.disabled = false;
    root.dataset.bundleOutOfStock = 'false';
    if (atcBtn.dataset.bound === 'true') return;
    atcBtn.dataset.bound = 'true';
    atcBtn.addEventListener('click', function () {
      addBundleToCart(root);
    });
  }

  if (!customElements.get('bundle-contents')) {
    customElements.define(
      'bundle-contents',
      class BundleContents extends HTMLElement {
        connectedCallback() {
          loadAndRender(this);
        }
      }
    );
  }
})(typeof window !== 'undefined' ? window : this);
